import { forwardRef } from "react";
import { HighlightItem } from "./HighlightItem";
import type { HighlightArea } from "./Search.types";

export const DOCUMENT_TOP_BOTTOM_PADDING = "1rem";

type HighlightLayerProps = {
  totalNoOfPages: number;
  pageDimensions: {
    [pageIndex: number]: {
      height: number;
      width: number;
    };
  };
  highlightAreasMapping: {
    [pageIndex: number]: HighlightArea[];
  };
};

export const HighlightLayer = forwardRef<HTMLDivElement, HighlightLayerProps>(
  (
    {
      highlightAreasMapping,
      pageDimensions,
      totalNoOfPages
    }: HighlightLayerProps,
    ref
  ) => {
    return (
      <div
        ref={ref}
        style={{
          display: "flex",
          position: "absolute",
          top: DOCUMENT_TOP_BOTTOM_PADDING,
          flexDirection: "column",
          gap: "1rem"
        }}
      >
        {Array.from(new Array(totalNoOfPages)).map((_, index) => (
          <div
            style={{
              height: pageDimensions[index]?.height,
              width: pageDimensions[index]?.width,
              position: "relative"
            }}
            data-testid={`search__highlights_page_index_${index}`}
            key={index}
          >
            {highlightAreasMapping[index]?.map((area, index) => (
              <HighlightItem index={index} key={index} area={area} />
            ))}
          </div>
        ))}
      </div>
    );
  }
);
